import { render, staticRenderFns } from "./Shouyou.vue?vue&type=template&id=9b91f45e&scoped=true&"
import script from "./Shouyou.vue?vue&type=script&lang=js&"
export * from "./Shouyou.vue?vue&type=script&lang=js&"
import style0 from "./Shouyou.vue?vue&type=style&index=0&id=9b91f45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b91f45e",
  null
  
)

export default component.exports